import { Routes, Route} from "react-router";
import App from 'pages/App';
import PlaceDashboardComponent from 'pages/places/dashboard/PlaceDashboardComponent';
import MyAccount from 'pages/places/my-account/MyAccount';

import PlacesHome from 'pages/places/home/PlacesHome'
import BackofficeHome from 'pages/backoffice/home/BackofficeHome'
import ShareLead from 'pages/places/share-lead/ShareLead'
import AvailableLeadDetails from "pages/places/available-lead-details/AvailableLeadDetails";
import FollowedLeadDetails from "pages/places/followed-lead-details/FollowedLeadDetails";
import FollowedLeads from "pages/places/followed-leads/FollowedLeads";
import SharedLeads from "pages/places/shared-leads/SharedLeads"
import BackofficeDashboard from "pages/backoffice/dashboard/BackofficeDashboard"
import BackofficeLeadsToValidate from "pages/backoffice/leads-to-validate/BackofficeLeadsToValidate"
import BackofficeValidateLead from "pages/backoffice/lead-to-validate-details/BackofficeValidateLead"
import LeadsToClose from "pages/places/leads-to-close/LeadsToClose"
import LeadToCloseDetails from "pages/places/lead-to-close-details/LeadToCloseDetails"
import BackofficeBillsToValidate from "pages/backoffice/bills-to-validate/BackofficeBillsToValidate"
import BackofficeBillToValidate from "pages/backoffice/bill-to-validate-details/BackofficeBillToValidate"
import SharedLeadDetails from "pages/places/shared-lead-details/SharedLeadDetails"
import AvailableLeads from "pages/places/available-leads/AvailableLeads";
import AllLeads from "pages/backoffice/all-leads/AllLeads";
import AllLeadDetails from "pages/backoffice/all-lead-details/AllLeadDetails";

const AppRoutes = () => (
    <Routes>
      <Route index element={<App />} />
      <Route path="places" element={<PlacesHome/>}>
        <Route path="dashboard" element={<PlaceDashboardComponent />} />
        <Route path="my-account" element={<MyAccount />} />
        <Route path="share-a-lead" element={<ShareLead />} />
        <Route path="shared-leads" element={<SharedLeads />} />
        <Route path="available-leads" element={<AvailableLeads   />} />
        <Route path="available-leads/:leadId" element={<AvailableLeadDetails />} />
        <Route path="leads/shared/:leadId" element={<SharedLeadDetails />} />
        <Route path="leads/followed" element={<FollowedLeads />} />
        <Route path="leads/followed/:leadId" element={<FollowedLeadDetails />} />
        <Route path="leads/to-close" element={<LeadsToClose />} />
        <Route path="leads/to-close/:leadId" element={<LeadToCloseDetails />} />
      </Route>
      <Route path="backoffice" element={<BackofficeHome/>}>
        <Route path="dashboard" element={<BackofficeDashboard />} />
        <Route path="leads/all" element={<AllLeads />} />
        <Route path="leads/all/:leadId" element={<AllLeadDetails />} />
        <Route path="leads/to-validate" element={<BackofficeLeadsToValidate />} />
        <Route path="leads/to-validate/:leadId" element={<BackofficeValidateLead/>} />
        <Route path="leads/bills-to-validate" element={<BackofficeBillsToValidate/>} />
        <Route path="leads/bills-to-validate/:leadId" element={<BackofficeBillToValidate/>} />
      </Route>
    </Routes>
);

export default AppRoutes;